'use client';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Loading } from '../Loading';
import { cn } from '@/lib/utils';

interface Props extends PropsWithChildren {
  delayTime?: number;
  onInteract?: boolean;
  noscriptFallback?: React.ReactNode;
  className?: string;
}

const LoadOnInteract: React.FC<Props> = ({
  children,
  noscriptFallback,
  className,
}) => {
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    const handleUserInteraction = () => {
      setHasInteracted(true);
      // Remover os listeners para evitar execuções repetidas
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('mousemove', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
      window.removeEventListener('scroll', handleUserInteraction);
    };

    // Adicionar eventos para detectar interações do usuário
    window.addEventListener('click', handleUserInteraction);
    window.addEventListener('mousemove', handleUserInteraction);
    window.addEventListener('keydown', handleUserInteraction);
    window.addEventListener('scroll', handleUserInteraction);

    return () => {
      // Limpar os eventos ao desmontar o componente
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('mousemove', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
      window.removeEventListener('scroll', handleUserInteraction);
    };
  }, []);

  return (
    <>
      {noscriptFallback && (
        <noscript>
          <style>{`.load-on-interact-gated { display: none !important; }`}</style>
          {noscriptFallback}
        </noscript>
      )}
      <div className={cn('load-on-interact-gated', className)}>
        {hasInteracted ? (
          <>{children}</>
        ) : (
          <div className="w-full my-4 flex items-center justify-center">
            <Loading />
          </div>
        )}
      </div>
    </>
  );
};

export default LoadOnInteract;
